(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whatsapp-float"] && !Shopify.designMode) return;
  try {
    // Teleport the button to <body> so its position:fixed escapes the section's
  // stacking context. Otherwise page content (e.g. product cards raised on hover)
  // can paint on top of it regardless of z-index.
  class WhatsAppFloatButton extends HTMLElement {
    connectedCallback() {
      if (this.dataset.teleported) return;
      this.dataset.teleported = 'true';

      // Remove any previous instance for this block (theme editor re-renders).
      const blockId = this.dataset.blockId;
      document.querySelectorAll('whatsapp-float-button[data-teleported]').forEach((el) => {
        if (el !== this && el.dataset.blockId === blockId) el.remove();
      });

      document.body.appendChild(this);
    }
  }

  if (!customElements.get('whatsapp-float-button')) {
    customElements.define('whatsapp-float-button', WhatsAppFloatButton);
  }
  } catch(e) { console.error(e); }
})();

})();
